import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Upload.tsx
const UploadIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		d: "M5 15.5a1 1 0 0 1 1 1v2h12v-2a1 1 0 1 1 2 0v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1Z",
		fill: props.fill || "currentColor"
	}), /* @__PURE__ */ jsx("path", {
		d: "M12 16.5a1 1 0 0 0 1-1V6.914l2.293 2.293a1 1 0 1 0 1.414-1.414l-4-4a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 6.914V15.5a1 1 0 0 0 1 1Z",
		fill: props.fill || "currentColor"
	})]
}));
//#endregion
export { UploadIcon };
